import { G } from './icons.tsx';

/**
 * Participant avatar.
 *
 * No uploaded avatars exist for visitors — a visitor supplies only a display
 * name — so this derives an initial, and falls back to a neutral glyph when even
 * the name is unreadable in this browser.
 */
export function Avatar({
  name,
  size = 'md',
  className,
}: {
  name?: string | null;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}) {
  const initial = name?.trim()?.[0]?.toUpperCase();
  const classes = ['av', size === 'md' ? '' : `av--${size}`, className ?? '']
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classes} aria-hidden="true">
      {initial ?? <G n="user" size={size === 'lg' ? 96 : size === 'xs' ? 16 : 26} />}
    </span>
  );
}
